import React, { useState, useEffect } from 'react';
import './CarouselBanner.css';

export default function CarouselBanner({ informativos, onInformativoClick }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Filtrar informativos com imagens (não PDFs)
  const bannerItems = informativos.filter(
    inf => inf.images && inf.images.length > 0 && !inf.images[0].toLowerCase().endsWith('.pdf')
  );

  const apiBase = process.env.REACT_APP_URL_BASE || '';
  const apiOrigin = apiBase.replace(/\/api\/?$/i, '').replace(/\/$/, '');

  useEffect(() => {
    if (bannerItems.length === 0) return () => {};

    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex === bannerItems.length - 1 ? 0 : prevIndex + 1));
    }, 5000); // Troca a cada 5 segundos

    return () => clearInterval(interval);
  }, [bannerItems.length]);

  if (bannerItems.length === 0) return null;

  const currentItem = bannerItems[currentIndex];

  return (
    <div className="carousel-banner">
      <div
        className="carousel-container clickable"
        onClick={() => onInformativoClick && onInformativoClick(currentItem)}
        role="button"
        tabIndex={0}
        onKeyPress={e => e.key === 'Enter' && onInformativoClick && onInformativoClick(currentItem)}
      >
        <img
          src={`${apiOrigin}/uploads/${currentItem.images[0]}`}
          alt={currentItem.title}
          className="carousel-image"
        />
        <div className="carousel-overlay">
          <h2 className="carousel-title">{currentItem.title}</h2>
          {currentItem.description && (
            <p className="carousel-description">
              {currentItem.description.substring(0, 100)}
              {currentItem.description.length > 100 ? '...' : ''}
            </p>
          )}
        </div>
      </div>

      {/* Indicadores */}
      <div className="carousel-indicators">
        {bannerItems.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
}
